import React, { useState, useMemo } from 'react';
import TextBox from 'components/TextBox';
import {
  ColumnHeaderContainer,
  SearchContainer,
  SearchIcon,
  SearchInput
} from 'pages/SolutionDefinition/SolutionDefinition.styled';
import { PlaceholderDiv } from 'components/Tables/GapsDescriptionTable/GapsDescriptionTable.styled';

export const useSearchableColumn = (
  data: any[],
  searchProperty: string,
  title = 'Interpretation Baseline',
  renderComponent?: any
) => {
  const [searchText, setSearchText] = useState('');
  const [showSearch, setShowSearch] = useState(false);

  const filteredData = useMemo(() => {
    if (!searchText.trim()) return [];
    return (
      data?.filter((item: any) =>
        item[searchProperty]?.toLowerCase().includes(searchText.toLowerCase())
      ) || []
    );
  }, [data, searchText, searchProperty]);

  const column = useMemo(() => {
    const width = showSearch ? 700 : 500;

    // Check if this is for gaps (has a custom render component or non-default title)
    const isGapsColumn = renderComponent != null;

    return {
      title: () => (
        <ColumnHeaderContainer>
          <span>{title}</span>
          <SearchContainer>
            <SearchIcon onClick={() => setShowSearch(!showSearch)} />
            {showSearch && (
              <SearchInput
                placeholder='Search'
                value={searchText}
                onChange={(e: any) => setSearchText(e.target.value)}
                autoFocus
              />
            )}
          </SearchContainer>
        </ColumnHeaderContainer>
      ),
      width,
      render: isGapsColumn
        ? () => <PlaceholderDiv width={width} height={20} />
        : () => <TextBox width={width} />
    };
  }, [showSearch, searchText, title]);

  return { searchText, showSearch, filteredData, column };
};
